import { components } from 'react-select';

const Input = ({ autoComplete, ...props }) => (
  <components.Input {...props} autoComplete="new-place" />
);

export default Input;
